import  React from 'react';
import _ from 'underscore';

import { GeneralInput } from './general_text_input.jsx';
import PreviousResponse from '../previous-response/previous_response.jsx';

export default class SelectDropdown extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      show: false,
    }
  }

  onOptionSelected(key, value) {
    this.setState({
      show: false
    });
    this.props.onValueChange({
      key,
      value
    });
  }

  toggleVisible() {
    this.setState({
      show: !this.state.show
    });
  }

  /* dead code 
  addAdditionalData(value) {
    this.props.onValueChange({
      key: this.props.value.key,
      value: this.props.value.value,
      additional: value
    });
  } */

  hide(e) {

    if(this.state.show) {
      let currentTarget = e.currentTarget;

      setTimeout(function() {
        if (!currentTarget.contains(document.activeElement)) {
          this.setState({
            show: false
          });
        }
      }.bind(this), 0);

    }
  }

  render() {
    let options = this.props.options;
    let strings = this.props.strings;

    //Adds "other" option to dropdown
    if (options.indexOf("OTHER") == -1 && this.props.other.otherOption)
      options.push("OTHER");

    if(options.indexOf("CLEAR") === -1 && this.props.enableClearSelection){
      options.push("CLEAR")
      strings["CLEAR"] = this.props.clearSelectionText
    }

    if(this.props.defaultConditionalValue && !this.props.value.value){
      const index = options.indexOf(this.props.defaultConditionalValue)
      if(index > -1) this.onOptionSelected(index, this.props.defaultConditionalValue)
    }

    const list = _.map(options, (val, key) => {
      return(
        <div className="options" key={key} onClick={() => this.onOptionSelected(key, val)}>
          <div className="radio">
            <div className={"fill " + (this.props.value.key == key ? "check" :  "")}></div>
          </div>
          <span className="value" id={val}>
            <div>{strings[val] || val }</div>
          </span>
        </div>
      );
    });

    var stringValue = this.props.default;
    if (this.props.value.value) {
      if (strings[this.props.value.value])
        stringValue = strings[this.props.value.value];
      else
        stringValue = this.props.value.value;
    }

    return (
      <div id={this.props.id} className="select-dropdown">
        <div className="head">{this.props.title}{this.props.mandatory && <span className="mandatory-asterix"> *</span>}</div>
        {
          this.props?.lastSurveyResponseText && (
            <PreviousResponse
              responseHeader={this.props.lastSurveyResponseHeader}
              responseText={this.props.lastSurveyResponseText}
            />
          )
        }
        { this.state.hideDropdown ? null :
          <div
            className={"dropdown-box"}
            tabIndex="0"
            id={this.props.id + "Input"}
            onBlur={(e) => { this.hide(e) }} >
            <div
              className={"selected-option" + (this.state.show ? ' active' : '') + (_.isEmpty(this.props.options) ? " disabled" : "")}
              onClick={!_.isEmpty(this.props.options) ? () => this.toggleVisible() : null}
              style={{"height": "40px"}}
            >
              <div className="value">{ stringValue }</div>
              <div className="arrow"/>
            </div>
            {this.state.show ? <div className="list-box">
              {list}
            </div> : null}
          </div>
        }
      </div>
    );
  }
}

SelectDropdown.defaultProps = {
  mandatory: false,
  enableClearSelection: false,
  clearSelectionText:null
};
